module.exports = __webpack_public_path__ + "img/videoteam.b7a48259.png";